import React, { useState } from "react";
import { useHistory } from "react-router-dom";

// reactstrap components
import {Button,Card,CardBody,FormGroup,Form,Input,InputGroupAddon,InputGroupText,InputGroup,Row,Col,CardHeader} from "reactstrap";
import { login, newUser } from "../../network/ApiAxios";
import AppleLogin from 'react-apple-login'
import axios from 'axios';
import { Apple } from '@material-ui/icons';

import { GoogleOAuthProvider,GoogleLogin  } from '@react-oauth/google';
import jwtDecode from 'jwt-decode';

const Login = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [appleServerResponse, setAppleServerResponse] = useState();
  const history = useHistory();

  const tryLogin = async () => {
    const response = await login(email, password);
    console.log(response)
    const { data } = response;
    if (data.success) {
      setError("");
      const tokenAge = new Date();
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      localStorage.setItem("tokenAge", tokenAge);
      //props.history.push("/user");
      //props.history.push("/" + data.user.role);
      history.push("/" + data.user.role);
    } else {
      setPassword("");
      setError(data.msg);
    }
  };

  const appleResponse = response => {
    if (!response.error) {
      axios
        .post("/auth/ios", response)
        .then(async res => {
          setAppleServerResponse(res.data)
          if(res.data.state == 'register'){
            //case state is register
            const registerResp = await newUser(res.data.name,res.data.email,'celebrationjump','user')
            if(registerResp.data.success){
              const responseLogin = await login(res.data.email, 'celebrationjump');
              console.log(responseLogin)
              const { data } = responseLogin;
              if (data.success) {
                setError("");
                const tokenAge = new Date();
                localStorage.setItem("token", data.token);
                localStorage.setItem("user", JSON.stringify(data.user));
                localStorage.setItem("tokenAge", tokenAge);
                history.push("/" + data.user.role);
              } else {
                setPassword("");
                setError(data.msg);
              }
            }
          }else if(res.data.state == true){
            //login successfull
            const tokenAge = new Date();
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("user", JSON.stringify(res.data.user));
            localStorage.setItem("tokenAge", tokenAge);
            history.push("/" + res.data.user.role);
            
          }else{
            //login failed
            setPassword("");
            setError(res.data.msg || 'IOS Login Failed');
          }
        })
        .catch(err => console.log(err));
    }
  };


  const googleResponse = (userInfo)=>{
    axios
        .post("/auth/google", userInfo)
        .then(async res => {
          setAppleServerResponse(res.data)
          if(res.data.state == 'register'){
            //case state is register
            const registerResp = await newUser(res.data.name,res.data.email,'celebrationjump','user')
            if(registerResp.data.success){
              const responseLogin = await login(res.data.email, 'celebrationjump');
              console.log(responseLogin)
              const { data } = responseLogin;
              if (data.success) {
                setError("");
                const tokenAge = new Date();
                localStorage.setItem("token", data.token);
                localStorage.setItem("user", JSON.stringify(data.user));
                localStorage.setItem("tokenAge", tokenAge);
                history.push("/" + data.user.role);
              } else {
                setPassword("");
                setError(data.msg);
              }
            }
          }else if(res.data.state == true){
            //login successfull
            const tokenAge = new Date();
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("user", JSON.stringify(res.data.user));
            localStorage.setItem("tokenAge", tokenAge);
            history.push("/" + res.data.user.role);
            
          }else{
            //login failed
            setPassword("");
            setError(res.data.msg || 'Google Login Failed');
          }
        })
        .catch(err => console.log(err));
  }



  return (
    <>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">
          <CardHeader className="bg-transparent pb-5 text-center">
            <Col md='6' className="justify-content-center d-flex center row">
              <AppleLogin
                clientId="com.celebrationjump.CeleApp"
                redirectURI="https://celebrationjump.com/auth/ios"
                usePopup={true}
                callback={appleResponse} // Catch the response
                scope="email name"
                responseMode="query"
                render={renderProps => (  //Custom Apple Sign in Button
                          <Button onClick={renderProps.onClick} style={{backgroundColor: "white",border: "1px solid black",
                                  fontFamily: "none",lineHeight: "25px",fontSize: "15px",marginRight:'0px',marginBottom:'10px'}}>
                                <Apple className='mt--2 mr-2 ml--2'/>
                                Sign in 
                          </Button>
                            )}
              />
              <GoogleOAuthProvider clientId="825027271259-3ce8f0bdoe1qehakgdlqukoeoqs763d5.apps.googleusercontent.com">
                <GoogleLogin theme="outline" text="signin"
                  onSuccess={async  (credentialResponse) => {
                    const userInfo = jwtDecode(credentialResponse.credential)
                    googleResponse(userInfo)
                  }}
                  onError={() => {
                    console.log('Login Failed');
                    setError('Google Login Failed')
                  }}
                />
              </GoogleOAuthProvider>
            </Col>
          </CardHeader>
          <CardBody className="px-lg-5 py-lg-5">
            <div className="text-center text-muted mb-4">
              <small>Sign in with credentials</small>
            </div>
            <Form role="form">
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  {/*<InputGroupAddon addonType="prepend">*/}
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  {/*</InputGroupAddon>*/}
                  <Input
                    placeholder="Email"
                    type="email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  {/*<InputGroupAddon addonType="prepend">*/}
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  {/*</InputGroupAddon>*/}
                  <Input
                    placeholder="Password"
                    type="password"
                    autoComplete="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </InputGroup>
              </FormGroup>
              {/*<div className="custom-control custom-control-alternative custom-checkbox">*/}
              {/*    <input*/}
              {/*        className="custom-control-input"*/}
              {/*        id=" customCheckLogin"*/}
              {/*        type="checkbox"*/}
              {/*    />*/}
              {/*    <label*/}
              {/*        className="custom-control-label"*/}
              {/*        htmlFor=" customCheckLogin"*/}
              {/*    >*/}
              {/*        <span className="text-muted">Remember me</span>*/}
              {/*    </label>*/}
              {/*</div>*/}
              {error ? (
                <div className="text-muted font-italic">
                  <small>
                    error:{" "}
                    <span className="text-red font-weight-700">{error}</span>
                  </small>
                </div>
              ) : null}
              <div className="text-center">
                <Button
                  className="my-4"
                  color="primary"
                  type="button"
                  onClick={tryLogin}
                >
                  Sign in
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
        <Row className="mt-3">
          <Col xs="6">
            <a
              href="reset-password" 
              className="text-light"
              onClick={() => props.history.push("/auth/reset-password")}
            >
              <small>Forgot password?</small>
            </a>
          </Col>
          <Col className="text-right" xs="6">
            <a
              href="register"
              className="text-light"
              onClick={() => props.history.push("/auth/register")}
            >
              <small>Create new account</small>
            </a>
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default Login;
